<style lang="less">
@import "./main.less";
@import "../less/common.less";
</style>
<template>
  <div class="main">
    <!-- 位数对应模块：0 abc 1 调度 2 人脸 3 数据中心 4 价格带 5 时间段 -->
    <div class="main-content">
      <div class="sunlight"></div>
      <div class="sunlight"></div>
      <div class="sunlight"></div>
      <div class="sunlight"></div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="jum">
            <a href="JavaScript:;" @click="toDetail('/productABC','Intelligent.ProductABC')">
              <div class="jumbotron" v-allow="'main_Intelligent.ProductABC'">
                <div>
                  <img src="../image/abc.png" alt="..." />
                  <h4>商品ABC</h4>
                </div>
              </div>
            </a>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="jum">
            <a href="JavaScript:;" @click="toDetail('/dispatchCenter','Intelligent.DispatchCenter')">
              <div class="jumbotron" v-allow="'main_Intelligent.DispatchCenter'">
                <div>
                  <img src="../image/dispatch.png" alt="..." />
                  <h4>调度中心</h4>
                </div>
              </div>
            </a>
            <div>&nbsp;</div>
            <a href="JavaScript:;" @click="toDetail('/dataBrain','Intelligent.DataBrain')">
              <div class="jumbotron" v-allow="'main_Intelligent.DataBrain'">
                <div>
                  <img src="../image/dataBrain.png" alt="..." />
                  <h4>数据大脑</h4>
                </div>
              </div>
            </a>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="jum">
            <a href="JavaScript:;" @click="toDetail('/priceAnalysis','Intelligent.PriceAnalysis')">
              <div class="jumbotron" v-allow="'main_Intelligent.PriceAnalysis'">
                <div>
                  <img src="../image/price.png" alt="..." />
                  <h4>价格带分析</h4>
                </div>
              </div>
            </a>
            <div>&nbsp;</div>
            <a href="JavaScript:;" @click="toDetail('/passflowAnalysis','Intelligent.PassengerFlow')">
              <div class="jumbotron" v-allow="'main_Intelligent.PassengerFlow'">
                <div>
                  <img src="../image/face.png" alt="..." />
                  <h4>人脸客流分析</h4>
                </div>
              </div>
            </a>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="jum">
            <a href="JavaScript:;" @click="toDetail('/timeSaleAnalysis','Intelligent.TimeSaleAnalysis')">
              <div class="jumbotron" v-allow="'main_Intelligent.TimeSaleAnalysis'">
                <div>
                  <img src="../image/time.png" alt="..." />
                  <h4>时间段分析</h4>
                </div>
              </div>
            </a>
            <div>&nbsp;</div>
            <a href="JavaScript:;" @click="toDetail('/')">
              <div class="jumbotron" v-allow="'main_Intelligent.AccountManagement'">
                <div>
                  <img src="../image/account.png" alt="..." />
                  <h4>账号管理</h4>
                </div>
              </div>
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { localToken } from "@/libs/util";
export default {
  name: "main",
  data() {
    return {};
  },
  methods: {
    toDetail(path, name = false) {
      let that = this;
      if (name) {
        let permissGroup = JSON.parse(localToken.getConfiguration());
        let permissGropName = name.split(".")[0];
        if (permissGroup[permissGropName].indexOf(name) == -1) {
        } else {
          that.$router.push({ path: path });
        }
      } else {
        that.$router.push({ path: path });
      }
    },
  },
  mounted() {},
};
</script>
<style>
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/view/main/main.vue